import React from 'react';
import { Box, makeStyles, Grid } from '@material-ui/core';
import { RecordVoiceOver } from '@material-ui/icons';
import Body1 from '../../../../common/typographys/Body1';
import Body2 from '../../../../common/typographys/Body2';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  proposalEntry: {
    padding: '12px 14px',
    marginTop: '8px',
    backgroundColor: theme.palette.neutrals[3],
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.primary[100],
    },
  },
  labelProposal: {
    marginLeft: '4px',
  },
  proposalSelected: {
    background: theme.palette.primary[100],
    borderLeft: `6px solid ${theme.palette.primary.A400}`,
    padding: '12px 14px 12px 8px',
    pointerEvents: 'none',
  },
  button: {
    display: 'flex',
  },
  iconContainer: {
    height: '35px',
    width: '35px',
    borderRadius: '100%',
    '&:hover': {
      background: theme.palette.primary[200],
    },
  },
  icon: {
    margin: '5px',
  },
}));

export const BEFORE_DAY_ORDER_ITEM_TYPE = 'before-day-order-item';

const BeforeDayOrderItemsList = ({ items, handleInfo, handleImmediateDiscussion, activeInfo }) => {
  const classes = useStyles();

  const onImmediateClick = (item, idxProposal, cb) => e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    return cb && cb({ ...item, type: BEFORE_DAY_ORDER_ITEM_TYPE }, null, idxProposal)();
  };

  return items.map((item, idxProposal) => (
    <Box
      key={item.id}
      className={clsx(classes.proposalEntry, {
        [classes.proposalSelected]:
          activeInfo.idxProposal === idxProposal &&
          activeInfo.idxTheme === null &&
          activeInfo.type === BEFORE_DAY_ORDER_ITEM_TYPE,
      })}
      onClick={handleInfo({ ...item, type: BEFORE_DAY_ORDER_ITEM_TYPE }, null, idxProposal)}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs={9}>
          <Body2>{item.type_name}</Body2>
          {item.title && <Body1 className={classes.labelProposal}>{item.title}</Body1>}
        </Grid>
        {handleImmediateDiscussion && (
          <Grid item xs={3}>
            <Grid container alignItems="flex-end" spacing={1}>
              <Grid xs={6} item />
              <Grid
                xs={6}
                item
                onClick={onImmediateClick(item, idxProposal, handleImmediateDiscussion)}
                className={classes.button}
              >
                <div className={classes.iconContainer}>
                  <RecordVoiceOver className={classes.icon} />
                </div>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  ));
};

BeforeDayOrderItemsList.defaultProps = {
  handleImmediateDiscussion: null,
};

BeforeDayOrderItemsList.propTypes = {
  items: PropTypes.array.isRequired,
  handleInfo: PropTypes.func.isRequired,
  handleImmediateDiscussion: PropTypes.func,
  activeInfo: PropTypes.object.isRequired,
};

export default React.memo(BeforeDayOrderItemsList);
